module.exports = new __parcel__URL__("first_tab_content_ko.ce5523cc.webp").toString();